var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import classNames from "classnames";
import { Paragraph } from "@riseart/common";
import { artistCommentCls, artistCommentSmallCls, artistCommentMediumCls, artistCommentLargeCls, artistCommentAuthorCls, artistCommentAuthorDashCls } from "./Comment.less";
var ArtistComment = /* @__PURE__ */ __name(function ArtistComment2(_ref) {
  var children = _ref.children, _ref$size = _ref.size, size = _ref$size === void 0 ? "large" : _ref$size, _ref$author = _ref.author, author = _ref$author === void 0 ? null : _ref$author, _ref$includeQuotes = _ref.includeQuotes, includeQuotes = _ref$includeQuotes === void 0 ? false : _ref$includeQuotes, _ref$showAuthorDash = _ref.showAuthorDash, showAuthorDash = _ref$showAuthorDash === void 0 ? false : _ref$showAuthorDash;
  var quote = includeQuotes ? /* @__PURE__ */ React.createElement(React.Fragment, null, '"') : null;
  return /* @__PURE__ */ React.createElement("div", {
    className: classNames(artistCommentCls, size === "small" && artistCommentSmallCls, size === "medium" && artistCommentMediumCls, size === "large" && artistCommentLargeCls)
  }, /* @__PURE__ */ React.createElement(Paragraph, null, quote, children, quote), author ? /* @__PURE__ */ React.createElement("div", {
    className: classNames(artistCommentAuthorCls, showAuthorDash && artistCommentAuthorDashCls)
  }, author) : null);
}, "ArtistComment");
export {
  ArtistComment
};
